/* eslint-disable camelcase */
/* eslint-disable import/no-extraneous-dependencies */
import React, { useState } from 'react'
import parse from 'html-react-parser'
import PropTypes from 'prop-types'
import { IoIosArrowDown } from '@react-icons/all-files/io/IoIosArrowDown'
import replaceMedia from '../../../helpers/replaceMedia'
import styles from './content.module.scss'
import lists from './lists/lists.module.scss'
import table from './table/table.module.scss'
import frame from './frame/frame.module.scss'
import blockquote from './blockquote.module.scss'

const Content = ({
  module,
  isHomepageFirstModule = false,
  isModuleIntroduction = '',
  page,
  pageTemplate,
  moduleName = 'content',
  isContentCollapsible = false,
  icon = <IoIosArrowDown />,
  moduleWidth = 960,
  modulePosition,
  customClass = ''
}) => {
  const { show_more_label, show_less_label, show_more_enabled } = module || {}

  const pageTemplateData = page?.template || pageTemplate;

  const [showMore, setShowMore] = useState(false)

  const handleChange = () => {
    setShowMore(!showMore)
  }

  const switchStyle = (style) => {
    switch (style) {
      case 'template_two':
        return `${table.templateTwo || ''}`
      case 'template_three':
        return `${table.templateOne || ''} ${frame.frame || ''}`
      default:
        return `${table.templateOne || ''}`
    }
  }

  const mainContent = (content, customClassName = '') => (
    <div
      className={` ${styles.content || ''} ${lists.ul || ''} ${blockquote.blockquote || ''
        } 
      ${styles[customClass] || ''}
      ${switchStyle(module.style) || ''} ${isHomepageFirstModule ? styles.homepageFirstModuleContent || '' : ''
        } ${isModuleIntroduction ? styles.moduleIntroMargin || '' : ''
        } ${customClassName}
      `}
    >
      {parse(content, {
        replace: (node) =>
          replaceMedia(node, moduleWidth, moduleName, pageTemplateData, modulePosition, styles, {
            siteName: page?.siteInfo?.site_name,
            pageTitle: page?.title,
            name: page?.relation?.name,
          })
      })}
    </div>
  )

  const mainContentTwo = (
    content,
    customClassName = '',
    showMoreText = false
  ) => (
    <div
      className={` ${styles.content || ''} ${lists.ul || ''} ${blockquote.blockquote || ''
        } 
      ${styles[customClass] || ''}
       ${showMore && !isContentCollapsible ? styles.showMore : ''}  
      ${switchStyle(module.style) || ''} ${isHomepageFirstModule ? styles.homepageFirstModuleContent || '' : ''
        } ${isModuleIntroduction ? styles.moduleIntroMargin || '' : ''
        } ${customClassName}
        ${showMoreText && !showMore ? styles.hide : ''}
      `}
    >
      {parse(content, {
        replace: (node) =>
          replaceMedia(node, moduleWidth, moduleName, pageTemplateData, modulePosition, styles, {
            siteName: page?.siteInfo?.site_name,
            pageTitle: page?.title,
            name: page?.relation?.name,
          })
      })}
    </div>
  )

  return show_more_enabled !== '1' || module.show_more_content == null ? (
    mainContent(module.value)
  ) : (
    <>
      {mainContent(module.value)}
      <button
        type="button"
        className={`${isContentCollapsible
          ? styles.showMoreTwoButton || ''
          : styles.showMoreButton || ''
          } ${(!isContentCollapsible && showMore && styles.hide) || ''} ${(showMore && isContentCollapsible && styles.showMoreTwoButtonOpen) ||
          ''
          }`}
        onClick={handleChange}
        title="showMoreContentButton"
      >
        {showMore ? show_less_label || show_more_label : show_more_label}
        {icon && isContentCollapsible && icon}
      </button>

      {module.show_more_content &&
        mainContentTwo(
          module.show_more_content,
          isContentCollapsible ? styles.contentCollapsibleBox : '',
          true
        )}
    </>
  )
}

Content.propTypes = {
  module: PropTypes.shape({
    anchor_label: PropTypes.string,
    name: PropTypes.string,
    module_title: PropTypes.string,
    value: PropTypes.string,
    style: PropTypes.string,
    show_more_content: PropTypes.string
  }),
  page: PropTypes.shape({
    template: PropTypes.string,
    title: PropTypes.string,
    relation: PropTypes.shape({ name: PropTypes.string }),
    siteInfo: PropTypes.shape({ site_name: PropTypes.string })
  }),
  pageTemplate: PropTypes.string,
  moduleName: PropTypes.string,
  isHomepageFirstModule: PropTypes.bool,
  isModuleIntroduction: PropTypes.string,
  isContentCollapsible: PropTypes.bool,
  icon: PropTypes.node,
  moduleWidth: PropTypes.node,
  modulePosition: PropTypes.number,
  customClass: PropTypes.string
}

export default Content